<template>
	<div class="shopOrders">
		<h1>Orders</h1>

		<div v-if="orders !== null && orders.length > 0">
			Total Orders {{ totalOrders }}
			<div class="list">
				<div v-for="(order, index) of orders" :key="index" class="orderItem">
					<div>
						{{ order.alias }}
					</div>
					<div class="center-align">
						{{ order.total_price.toLocaleString('en-GB') }}
					</div>
					<div>
						{{ convertTime(order.updatedAt) }}
					</div>
				</div>
			</div>
			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	data: () => ({
		orders: null,
		ordersTotal: null,
		shopId: null,
		limit: 20, // For pager
		pageCount: 1, // For pager
		page: 1 // For pager
	}),

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		if (this.$route.params.shopId) {
			this.shopId = this.$route.params.shopId
			await this.getOrders()
		} else {
			await this.getShops()
		}
	},

	methods: {
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				shop: this.shopId,
				limit: this.limit,
				skip
			}

			const apiGetOrders = await this.$api.getOrders({ data })

			if (apiGetOrders !== undefined) {
				this.pageCount = Math.ceil(apiGetOrders.data.total / this.limit)
				this.orders = apiGetOrders.data.list
			}
		},

		getOrders: async function() {
			const data = {
				shop: this.shopId,
				limit: 20
			}

			const apiGetOrders = await this.$api.getOrders({ data })

			if (apiGetOrders !== undefined) {
				this.totalOrders = apiGetOrders.data.total
				this.pageCount = Math.ceil(apiGetOrders.data.total / this.limit)
				this.orders = apiGetOrders.data.list
			}
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		},

		redirect: function() {
			const shopId = this.selectedShop._id

			this.$router.push({ name: 'shopOrders', params: { shopId } })
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
